import { render } from "./editRawMaterials.vue?vue&type=template&id=1c388204&scoped=true&ts=true"
import script from "./editRawMaterials.vue?vue&type=script&lang=ts"
export * from "./editRawMaterials.vue?vue&type=script&lang=ts"

import "./editRawMaterials.vue?vue&type=style&index=0&id=1c388204&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1c388204"]])

export default __exports__